"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderChart = void 0;
const react_1 = __importStar(require("react"));
const crate_1 = require("@tcc/crate");
const numberFormatter_1 = require("@/utils/numberFormatter");
const LineChartContext_1 = require("@/components/LineChart/context/LineChartContext");
const getMarkerPosition_1 = require("@/utils/getMarkerPosition");
const constants_1 = require("@/components/LineChart/constants");
exports.SliderChart = (0, react_1.memo)((_a) => {
    var _b, _c;
    var { dotIndex = 0 } = _a, props = __rest(_a, ["dotIndex"]);
    const { upperBound, lowerBound, datasetBounds } = (0, LineChartContext_1.useLineChartStaticContext)();
    const { dots, handleSliderChange } = (0, LineChartContext_1.useLineChartDynamicContext)();
    // Use dataset-specific bounds if available, fallback to global bounds
    const datasetBound = datasetBounds[dotIndex];
    const actualUpperBound = (_b = datasetBound === null || datasetBound === void 0 ? void 0 : datasetBound.upperBound) !== null && _b !== void 0 ? _b : upperBound;
    const actualLowerBound = (_c = datasetBound === null || datasetBound === void 0 ? void 0 : datasetBound.lowerBound) !== null && _c !== void 0 ? _c : lowerBound;
    const maxSlider = (0, react_1.useMemo)(() => (0, numberFormatter_1.formatNumberRoundUpToNearest)(actualUpperBound, constants_1.MAX_SLIDER_ROUND_VALUE), [actualUpperBound]);
    const minSlider = (0, react_1.useMemo)(() => (0, numberFormatter_1.formatNumberRoundDownToNearest)(actualLowerBound * 0.2, constants_1.MAX_SLIDER_ROUND_VALUE), [actualLowerBound]);
    const dot = dots[dotIndex] || { sliderValue: actualLowerBound.toFixed(0), inputValue: '', inputIsInValid: false };
    const marker = (0, react_1.useMemo)(() => (0, getMarkerPosition_1.getMarkerPosition)(Number(dot.sliderValue), minSlider, maxSlider), [dot.sliderValue, minSlider, maxSlider]);
    return (react_1.default.createElement(crate_1.Slider, Object.assign({ max: actualUpperBound, min: actualLowerBound, markers: [marker], handleSize: "SMALL", onChange: (value) => handleSliderChange(value, dotIndex) }, props)));
});
exports.SliderChart.displayName = 'SliderChart';
